import { render, staticRenderFns } from "./village-info-nearby.vue?vue&type=template&id=79f61550&scoped=true&"
import script from "./village-info-nearby.vue?vue&type=script&lang=js&"
export * from "./village-info-nearby.vue?vue&type=script&lang=js&"
import style0 from "./village-info-nearby.vue?vue&type=style&index=0&id=79f61550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f61550",
  null
  
)

export default component.exports